export default "__VITE_ASSET__BO4RmANM__"